import React, { useRef, useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import ReactConfetti from 'react-confetti';
import { FaCheckCircle, FaMapMarkerAlt, FaMapMarkedAlt, FaEnvelope, FaPhone, FaWhatsapp, FaCode, FaDesktop } from 'react-icons/fa';
import './ContactUs.css';

const PUBLIC_KEY = 'FXRINrJwtfHmHpCIT';
const SERVICE_ID = 'service_00vmrqp';
const TEMPLATE_ID = 'template_ign8guc';
// Paste your deployed Google Apps Script Web App URL inside the quotes below:
//const GOOGLE_SHEETS_URL = 'https://script.google.com/macros/s/AKfycbztdObiDzvqbTJ3MKZacEuy7yobXUahT2V00_QtLd38qKYNYtSPe5vgvrwkAVIAfeUc/exec'; 
const GOOGLE_SHEETS_URL = 'https://script.google.com/macros/s/AKfycbz8V5hlvIIf7c94SruBMRJK_sQ4IuoecdZ_7HRU8SJ6c0MBvZxtVTQul2dCRIPMlQNaxQ/exec';

const Content_New = () => {
  const form = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    companyName: '',
    mobileNumber: '',
    email: '',
    product: '',
    message: '',
  });

  const [activeSection, setActiveSection] = useState('contact-cover');

  useEffect(() => {
    const sections = ['contact-cover', 'contact-details', 'contact-form', 'contact-map'];
    
    const handleScroll = () => {
      const headerHeight = 90; // Fixed navbar offset
      let active = 'contact-cover';
      
      for (const id of sections) {
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          // If section top has passed the navbar header line
          if (rect.top <= headerHeight + 60) {
            active = id;
          }
        }
      }
      
      // Auto highlight map section when scrolled to bottom
      if ((window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight - 60) {
        active = 'contact-map';
      }
      
      setActiveSection(active);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const headerOffset = 90; // Align section exactly below the fixed navbar
      const elementPosition = el.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const sendEmail = (e) => {
    e.preventDefault();

    const templateParams = {
      to_name: 'Recipient',
      first_name: formData.firstName,
      last_name: formData.lastName,
      email: formData.email,
      mobile_number: formData.mobileNumber,
      company: formData.companyName,
      product: formData.product,
      message: formData.message,
    };

    // 1. Send data to Google Sheets in background
    if (GOOGLE_SHEETS_URL) {
      fetch(GOOGLE_SHEETS_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          companyName: formData.companyName,
          mobileNumber: formData.mobileNumber,
          email: formData.email,
          product: formData.product,
          message: formData.message,
        }),
      })
        .then(() => {
          console.log('Saved to Google Sheets successfully!');
        })
        .catch((error) => {
          console.error('Google Sheets saving error:', error);
        });
    } else {
      console.warn('Google Sheets URL is not configured. Form details not saved to sheet.');
    }

    // 2. Send email via EmailJS in background
    emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY)
      .then(() => {
        console.log('Email sent successfully via EmailJS!');
      })
      .catch((error) => {
        console.error('Email sending error (EmailJS):', error);
      });

    // 3. Immediately show the success modal and reset form for the user
    setIsModalOpen(true);
    // Easter Egg: confetti burst on form submit!
    setShowConfetti(true);
    setTimeout(() => setShowConfetti(false), 6000);
    form.current.reset();
    setFormData({
      firstName: '',
      lastName: '',
      companyName: '',
      mobileNumber: '',
      email: '',
      product: '',
      message: '',
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="contact-page-wrapper">
      {/* ── Full-Width Cover Hero Banner ── */}
      <section id="contact-cover" className="contact-hero" style={{ backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)), url("/contact/Contact-us.png")' }}>
      </section>

      <section className="contacts">
        <div className="contact-container">
          {/* ── Left Side: Contact Info ── */}
          <div id="contact-details" className="contact-info-section">
            <h1>Get in Touch</h1>
            <p className="client-description">
              Have a question or need a customized Tally solution? Our team is here to help you optimize your business operations.
            </p>

            <div className="contact-info-grid">
              {/* Office Address Card */}
              <div 
                className="innovative-contact-card address-card"
              >
                <a 
                  href="https://www.google.com/maps?ll=13.068722,80.216376&z=16&t=m&hl=en&gl=IN&mapclient=embed&cid=10554500636439021061" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', color: 'inherit', display: 'flex', flexDirection: 'column', gap: '20px' }}
                >
                  <div className="dept-info">
                    <div className="dept-icon-wrapper">
                      <FaMapMarkerAlt />
                    </div>
                    <div className="dept-texts">
                      <h3>Office Address</h3>
                      <span className="dept-tag">Headquarters</span>
                    </div>
                  </div>
                  <div className="dept-address">
                    <p>
                      iMatrix Technologies Pvt Ltd<br />
                      #R-76 MMDA Colony, Arumbakkam,<br />
                      Chennai - 600 106
                    </p>
                  </div>
                </a>
                <div className="dept-actions">
                  <a href="tel:+919841033443" className="action-pill phone-pill" title="Call Headquarters">
                    <FaPhone className="action-icon" />
                    <span className="action-text">+91 98410 33443</span>
                  </a>
                </div>
              </div>

              {/* TDL Customization */}
              <div className="innovative-contact-card">
                <div className="dept-info">
                  <div className="dept-icon-wrapper">
                    <FaEnvelope />
                  </div>
                  <div className="dept-texts">
                    <h3>TDL Customization</h3>
                    <span className="dept-tag">Tally Solutions</span>
                  </div>
                </div>
                <div className="dept-actions">
                  <a href="mailto:tdl@imatrixtechnologies.com" className="action-pill email-pill" title="Email TDL Customization">
                    <FaEnvelope className="action-icon" />
                    <span className="action-text">tdl@imatrixtechnologies.com</span>
                  </a>
                  <a href="tel:+919841594294" className="action-pill phone-pill" title="Call TDL Customization">
                    <FaPhone className="action-icon" />
                    <span className="action-text">+91 98415 94294</span>
                  </a>
                </div>
              </div>

              {/* Software Development */}
              <div className="innovative-contact-card">
                <div className="dept-info">
                  <div className="dept-icon-wrapper">
                    <FaCode />
                  </div>
                  <div className="dept-texts">
                    <h3>Software Development</h3>
                    <span className="dept-tag">Mobile, Web & Custom</span>
                  </div>
                </div>
                <div className="dept-actions">
                  <a href="mailto:development@imatrixtechnologies.com" className="action-pill email-pill" title="Email Software Development">
                    <FaEnvelope className="action-icon" />
                    <span className="action-text">development@imatrixtechnologies.com</span>
                  </a>
                  <a href="tel:+919500625633" className="action-pill phone-pill" title="Call Software Development">
                    <FaPhone className="action-icon" />
                    <span className="action-text">+91 95006 25633</span>
                  </a>
                </div>
              </div>

              {/* Hardware Department */}
              <div className="innovative-contact-card">
                <div className="dept-info">
                  <div className="dept-icon-wrapper">
                    <FaDesktop />
                  </div>
                  <div className="dept-texts">
                    <h3>Hardware Department</h3>
                    <span className="dept-tag">IT Infrastructure & Hardware</span>
                  </div>
                </div>
                <div className="dept-actions">
                  <a href="mailto:hardware@imatrixtechnologies.com" className="action-pill email-pill" title="Email Hardware Department">
                    <FaEnvelope className="action-icon" />
                    <span className="action-text">hardware@imatrixtechnologies.com</span>
                  </a>
                  <a href="tel:+919841545557" className="action-pill phone-pill" title="Call Hardware Department">
                    <FaPhone className="action-icon" />
                    <span className="action-text">+91 98415 45557</span>
                  </a>
                </div>
              </div>

              {/* Support */}
              <div className="innovative-contact-card">
                <div className="dept-info">
                  <div className="dept-icon-wrapper">
                    <FaEnvelope />
                  </div>
                  <div className="dept-texts">
                    <h3>Support</h3>
                    <span className="dept-tag">Technical Help</span>
                  </div>
                </div>
                <div className="dept-actions">
                  <a href="mailto:support@imatrixtechnologies.com" className="action-pill email-pill" title="Email Support">
                    <FaEnvelope className="action-icon" />
                    <span className="action-text">support@imatrixtechnologies.com</span>
                  </a>
                  <a href="tel:+919841609990" className="action-pill phone-pill" title="Call Support">
                    <FaPhone className="action-icon" />
                    <span className="action-text">+91 98416 09990</span>
                  </a>
                </div>
              </div>

              {/* Marketing */}
              <div className="innovative-contact-card">
                <div className="dept-info">
                  <div className="dept-icon-wrapper">
                    <FaEnvelope />
                  </div>
                  <div className="dept-texts">
                    <h3>Marketing</h3>
                    <span className="dept-tag">Sales & Queries</span>
                  </div>
                </div>
                <div className="dept-actions">
                  <a href="mailto:marketing@imatrixtechnologies.com" className="action-pill email-pill" title="Email Marketing">
                    <FaEnvelope className="action-icon" />
                    <span className="action-text">marketing@imatrixtechnologies.com</span>
                  </a>
                  <a href="tel:+919841609963" className="action-pill phone-pill" title="Call Marketing">
                    <FaPhone className="action-icon" />
                    <span className="action-text">+91 98416 09963</span>
                  </a>
                </div>
              </div>

              {/* WhatsApp Quick Chat */}
              <div className="innovative-contact-card">
                <div className="dept-info">
                  <div className="dept-icon-wrapper whatsapp-icon-bg">
                    <FaWhatsapp />
                  </div>
                  <div className="dept-texts">
                    <h3>WhatsApp</h3>
                    <span className="dept-tag">Quick Chat</span>
                  </div>
                </div>
                <div className="dept-actions">
                  <a href="https://wa.me/919841609990" target="_blank" rel="noopener noreferrer" className="action-pill whatsapp-pill" title="Chat on WhatsApp">
                    <FaWhatsapp className="action-icon" />
                    <span className="action-text">Chat: +91 98416 09990</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* ── Right Side: Form ── */}
          <div id="contact-form" className="contact-form-section">
            <h1>Send Message</h1>
            <form ref={form} className="contact-form" onSubmit={sendEmail}>
              <div className="form-row">
                <input type="text" name="firstName" placeholder="First Name" required onChange={handleChange} value={formData.firstName} />
                <input type="text" name="lastName" placeholder="Last Name" required onChange={handleChange} value={formData.lastName} />
              </div>

              <input type="text" name="companyName" placeholder="Company Name" required onChange={handleChange} value={formData.companyName} />

              <div className="form-row">
                <input type="text" name="mobileNumber" placeholder="Mobile Number" required onChange={handleChange} value={formData.mobileNumber} />
                <input type="email" name="email" placeholder="Email Address" required onChange={handleChange} value={formData.email} />
              </div>

              <select name="product" required onChange={handleChange} value={formData.product}>
                <option value="" disabled>Select a Service / Product</option>
                
                <optgroup label="Tally Solutions">
                  <option value="TallyPrime Gold">TallyPrime Gold (Multi-User)</option>
                  <option value="TallyPrime Silver">TallyPrime Silver (Single-User)</option>
                  <option value="Tally on Cloud">Tally on Cloud (AWS)</option>
                  <option value="Tally Customization">Tally Customization (TDL & API)</option>
                  <option value="TallyPrime Server">TallyPrime Server</option>
                  <option value="Tally WhatsApp Integration">Tally WhatsApp Integration</option>
                  <option value="Biz Analyst Mobile App">Biz Analyst Mobile App</option>
                </optgroup>

                <optgroup label="Web & Custom Software Solutions">
                  <option value="Web Application Development">Web Application Development</option>
                  <option value="Mobile App Development">Mobile App Development (iOS/Android)</option>
                  <option value="Fixed Asset Register">Fixed Asset Register (FAR)</option>
                  <option value="Purchase Request Module">Purchase Request Module (PR)</option>
                  <option value="Logistics Modules">Logistics Modules</option>
                  <option value="e-Warehouse Portal">e-Warehouse Portal</option>
                  <option value="Team 360 Portal">Team 360 Portal</option>
                  <option value="One Man Two Machine">One Man Two Machine (1M2M)</option>
                  <option value="Outstanding Reports & Collections Software">Outstanding Reports & Collections Software</option>
                  <option value="Enterprise Auto Backup Software">Enterprise Auto Backup Software</option>
                  <option value="Automated File Deletion Software">Automated File Deletion Software</option>
                </optgroup>

                <optgroup label="IT Infrastructure & Security">
                  <option value="Server Solutions">Server Setup & Solutions</option>
                  <option value="Biometric Access Systems">Biometric Access & Attendance</option>
                  <option value="CCTV Security Systems">CCTV Smart Surveillance</option>
                  <option value="Auto Backup Software">Auto Backup Software</option>
                  <option value="Antivirus & Endpoint Security">Antivirus & Endpoint Security</option>
                  <option value="Hardware Procurement">Laptops, Desktops & IT Hardware</option>
                  <option value="Printer Solutions">Printer Solutions & Sales</option>
                  <option value="IT Consulting & AMC">IT Consulting & AMC Contracts</option>
                </optgroup>
              </select>

              <textarea name="message" placeholder="Your Message" required onChange={handleChange} value={formData.message}></textarea>

              <button type="submit" className="submit-btn">Send Message</button>
            </form>
          </div>
        </div>

        {/* Easter Egg: Confetti on form submit */}
        {showConfetti && (
          <div style={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 99999 }}>
            <ReactConfetti
              width={window.innerWidth}
              height={window.innerHeight}
              recycle={false}
              numberOfPieces={350}
              opacity={0.85}
            />
          </div>
        )}

        {/* ── Success Modal ── */}
        {isModalOpen && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2><FaCheckCircle /> Message Sent! 🎉</h2>
              <p>Thank you for reaching out. You've joined <strong>3000+ businesses</strong> who trusted iMatrix! Our representative will contact you within <strong>24 hours</strong>.</p>
              <button className="close-btn" onClick={closeModal}>Close</button>
            </div>
          </div>
        )}


        {/* ── Map ── */}
        <div id="contact-map" className="map-section">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3916.2481050359854!2d80.21176271425258!3d13.06872741341825!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5266972fffffff%3A0x92791e68a0950605!2siMatrix%20Technologies%20Pvt%20Ltd!5e0!3m2!1sen!2sin!4v1695298143896!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Office Location"
          ></iframe>
        </div>
      </section>

      {/* Floating Pointed Dot Navigation */}
      <div className="floating-dot-nav" aria-label="Page section navigation">
        {[
          { id: 'contact-cover', label: 'Cover Banner' },
          { id: 'contact-details', label: 'Contact Details' },
          { id: 'contact-form', label: 'Send Message' },
          { id: 'contact-map', label: 'Office Map' }
        ].map((item) => (
          <button
            key={item.id}
            className={`dot-btn ${activeSection === item.id ? 'active' : ''}`}
            onClick={() => scrollToSection(item.id)}
            title={item.label}
            aria-label={`Scroll to ${item.label}`}
          >
            <span className="dot-tooltip">{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default Content_New;
